import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const mlaAddressLine2Viewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map